var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6007 0.515236C15.2616 0.697855 15.7821 1.23594 15.9587 1.91926C16.2797 3.15769 16.2797 5.74169 16.2797 5.74169C16.2797 5.74169 16.2797 8.3256 15.9587 9.56413C15.7821 10.2474 15.2616 10.7855 14.6007 10.9682C13.4029 11.3 8.59969 11.3 8.59969 11.3C8.59969 11.3 3.79645 11.3 2.59863 10.9682C1.93772 10.7855 1.41722 10.2474 1.24058 9.56413C0.919678 8.3256 0.919678 5.74169 0.919678 5.74169C0.919678 5.74169 0.919678 3.15769 1.24058 1.91926C1.41722 1.23594 1.93772 0.697855 2.59863 0.515236C3.79645 0.18335 8.59969 0.18335 8.59969 0.18335C8.59969 0.18335 13.4029 0.18335 14.6007 0.515236ZM7.1597 3.56664V8.39998L10.9997 5.9834L7.1597 3.56664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.4c38162a219153efeb02289c8ded7a49.svg";
export { ForwardRef as ReactComponent };